import React, { Fragment, useState } from 'react'
import { Table } from 'react-bootstrap'
import PropTypes from 'prop-types'

export const ViewKeysLink = props => {
  const [viewKey, toggleViewKey] = useState(false)
  let keys = (
    <Fragment>
      <Table striped bordered className="table-sm">
        <thead>
          <tr>
            <th>Key</th>
            <th>Secret</th>
          </tr>
        </thead>
        <tbody>
          {props.keyData.map((key, i) => (
            <tr key={i}>
              <td>{key[0]}</td>
              <td>{key[1]}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Fragment>
  )
  let icons = viewKey ? 'far fa-eye-slash fa-fw mr-2' : 'far fa-eye fa-fw mr-2'
  return (
    <Fragment>
      <div
        className="btn btn-myed btn-default btn-default-myed btn-sm-myed"
        onClick={() => toggleViewKey(!viewKey)}
      >
        <div className={icons} /> {viewKey ? 'Hide' : 'View'} Keys
      </div>
      {!viewKey ? '' : keys}
    </Fragment>
  )
}

ViewKeysLink.propTypes = {
  keyData: PropTypes.array,
}
